import { TableColumnMeta } from "ds/components/Table/types";

export enum FLOWS_PROJECTS_COLUMN_ID {
  NAME = "NAME",
  ASSIGNED_ROLES = "ASSIGNED_ROLES",
}

export const FLOWS_PROJECTS_COLUMNS_STORAGE_KEY = "flowsProjectsColumnsConfig";
export const FLOWS_PROJECTS_FILTERS_ORDER_KEY = "flowsProjectsFiltersOrder";

export const FLOWS_PROJECTS_COLUMN_CONFIG: Record<FLOWS_PROJECTS_COLUMN_ID, TableColumnMeta> = {
  [FLOWS_PROJECTS_COLUMN_ID.NAME]: {
    id: FLOWS_PROJECTS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 200,
    defaultWidth: 500,
    maxWidth: 2000,
    allowsSorting: true,
    resizable: true,
    canHide: false,
    canPin: false,
    canMove: false,
  },
  [FLOWS_PROJECTS_COLUMN_ID.ASSIGNED_ROLES]: {
    id: FLOWS_PROJECTS_COLUMN_ID.ASSIGNED_ROLES,
    title: "Assigned roles",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: 400,
    allowsSorting: true,
    resizable: true,
    canHide: false,
    canPin: false,
    canMove: false,
  },
};
